<template>
	<tmpl-default>
		<router-view />
	</tmpl-default>
</template>

<!-- <script src="./app.js"></script> -->

<script>
import { onMounted } from 'vue'
import { useUserSessionStore } from './stores/user-session-store'

onMounted(() => {
    const userSession = useUserSessionStore()
    userSession.load()
})
</script>

<style lang="scss">
@import './styles/main.scss';
</style>
